// Conversion milestone names pushed to the GTM data layer and captured by PostHog.

export const trackEvents = {
    portalLanding: "dc_portal_landing",
    pageView: "dc_page_view",
    signIn: "dc_sign_in",
    signUp: "dc_sign_up",
    intakeStart: "dc_intake_start",
    intakeStep: "dc_intake_step",
    consultationSubmit: "dc_consultation_submit",
    paymentComplete: "dc_payment_complete",
    bookingConfirmed: "dc_booking_confirmed",
};

// Consultation completion is deliberately not tracked: the client's milestone list covers the
// intake journey up to payment, and reporting a completed consultation would tie an analytics
// event to a clinical outcome.
